export const types = {
    login: '[Auth] Login',
    logout: '[Auth] Logout',
    setAuthAvailability: '[Auth] Set Availability',
    setAuthProfile: '[Auth] Set Profile',
    registerReset: '[Auth] Register Reset',
    registerPassword: '[Auth] Register Password',
    registerEmailName: '[Auth] Register Email Name',

    setCompany: '[Auth] Set Company',
    unsetCompany: '[Auth] Unset Company',
    updateEmailVerified: '[Company] Update Email Verified',
    updateCompanyName: '[Company] Update Name',
    updateCompanyLogo: '[Company] Update Logo',
    updateCompanySettings: '[Company] Update Settings',

    setError: '[UI] Set Error',
    unsetError: '[UI] Unset Error',
    startLoading: '[UI] Start Loading',
    finishLoading: '[UI] Finish Loading',
    startGlobalLoading: '[UI] Start Global Loading',
    finishGlobalLoading: '[UI] Finish Global Loading',
    toggleSidebar: '[UI] Toggle Sidebar',
    toggleStats: '[UI] Toggle Stats',
    toggleTicketFilters: '[UI] Toggle Ticket Filters',
    setVisibleTicketFilters: '[UI] Set Visible Ticket Filters',
    openSearchModal: '[UI] Open Search Modal',
    closeSearchModal: '[UI] Close Search Modal',
    openTicketCreateModal: '[UI] Open Ticket Create Modal',
    closeTicketCreateModal: '[UI] Close Ticket Create Modal',
    notifyTicketCreated: '[UI] Notify Ticket Created',
    setVisibleCustomers: '[UI] Set Visible Customers',
    setVisibleProjects: '[UI] Set Visible Projects',
    setVisibleTickets: '[UI] Set Visible Tickets',
    setVisibleUsers: '[UI] Set Visible Users',
    setVisibleRecords: '[UI] Set Visible Records',
    openOrFocusTicketTab: '[UI] Open Or Focus Ticket Tab',
    closeTicketTab: '[UI] Close Ticket Tab',
    setActiveTicketTab: '[UI] Set Active Ticket Tab',
    clearTicketTabs: '[UI] Clear Ticket Tabs',

    setMenu: '[Front] Set Menu',
}